import { isProd } from '../configs/env';

const prod = isProd();
const lowerDataProdsIdsProd = ['9342328930535', '9342327914727'];
const lowerDataProductsIdsStage = ['8974156464354', '8974157316322'];

// lower data products ids
export const LOWER_DATA_PRODUCTS_IDS = prod
  ? lowerDataProdsIdsProd
  : lowerDataProductsIdsStage;
